export const UserGroupIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <circle cx={20} cy={8.25} r={2.75} fill="#c4f0eb" />
      <path d="M23.5,15.5a3.5,3.5,0,0,0-7,0v3h1.583l.417,5h3l.417-5H23.5Z" fill="#c4f0eb" />
      <path
        d="M20,7.736a2.748,2.748,0,0,1,2.508,1.632,2.75,2.75,0,1,0-5.016,0A2.748,2.748,0,0,1,20,7.736Z"
        fill="#ffffff"
      />
      <path
        d="M20,12a3.5,3.5,0,0,0-3.5,3.5v2.236a3.5,3.5,0,0,1,7,0V15.5A3.5,3.5,0,0,0,20,12Z"
        fill="#ffffff"
      />
      <circle
        cx={20}
        cy={8.25}
        r={2.75}
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5,15.5a3.5,3.5,0,0,0-7,0v3h1.583l.417,5h3l.417-5H23.5Z"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={12} cy={2.75} r={2.25} fill="#c4f0eb" />
      <path d="M12,6A3,3,0,0,0,9,9v2.5h1.5L11,16h2l.5-4.5H15V9A3,3,0,0,0,12,6Z" fill="#c4f0eb" />
      <path
        d="M12,2.736a2.239,2.239,0,0,1,1.941,1.132A2.224,2.224,0,0,0,14.25,2.75a2.25,2.25,0,0,0-4.5,0,2.224,2.224,0,0,0,.309,1.118A2.239,2.239,0,0,1,12,2.736Z"
        fill="#ffffff"
      />
      <path d="M12,6A3,3,0,0,0,9,9v2.236a3,3,0,0,1,6,0V9A3,3,0,0,0,12,6Z" fill="#ffffff" />
      <circle
        cx={12}
        cy={2.75}
        r={2.25}
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12,6A3,3,0,0,0,9,9v2.5h1.5L11,16h2l.5-4.5H15V9A3,3,0,0,0,12,6Z"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={4} cy={8.25} r={2.75} fill="#c4f0eb" />
      <path d="M7.5,15.5a3.5,3.5,0,0,0-7,0v3H2.083l.417,5h3l.417-5H7.5Z" fill="#c4f0eb" />
      <path
        d="M4,7.736A2.748,2.748,0,0,1,6.508,9.368,2.748,2.748,0,1,0,1.25,8.25a2.729,2.729,0,0,0,.242,1.118A2.748,2.748,0,0,1,4,7.736Z"
        fill="#ffffff"
      />
      <path d="M4,12A3.5,3.5,0,0,0,.5,15.5v2.236a3.5,3.5,0,0,1,7,0V15.5A3.5,3.5,0,0,0,4,12Z" fill="#ffffff" />
      <circle
        cx={4}
        cy={8.25}
        r={2.75}
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5,15.5a3.5,3.5,0,0,0-7,0v3H2.083l.417,5h3l.417-5H7.5Z"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
